<template>
  <article>
    <h1>Card</h1>
    <div class="card">
      <template>
        <div class="overview-date">
          <span>Updated {{ reportDate | formatDateFromNow }}</span>
        </div>
        <ul>
          <li><h4>Total Assets</h4><span>{{ totalAmount | formatCurrency }}</span></li>
          <li><h4>Total Paid to You</h4><span>{{ totalPaid | formatCurrency }}</span></li>
        </ul>
      </template>
    </div>
  </article>
</template>

<script>
import moment from 'moment';
import filters from '@/lib/utils/filters';

export default {
  name: 'Overview',
  head: {
    title: 'Overview | PPI Valet',
  },
  filters,
  data() {
    return {
      totalAmount: 5728193.925,
      totalPaid: 67615.345,
      reportDate: moment('2017-08-31T21:06:40.099Z'),
    };
  },
};

</script>

<style lang="scss" scoped>


  .overview-date {
    text-align: right;
    color: $pearl-500;
    padding: 0.5rem 0.25rem;
    @media #{$screen-width-small} {
      border-bottom: none;
    }
  }
</style>
